import * as React from "react";
import { Row, Col } from "antd";
import styled from "styled-components";

import { ForwardNumberInput } from "../../../shared/ForwardNumberInput";
import { EntryComponentContainer } from "../../../shared/EntryComponentContainer";
import { LoadSelect } from "../../../shared/LoadSelect";
import { QuantityInput } from "../../../shared/QuantityInput";
import { Load } from "../../../lib/model/Load";
import { ForwardOutlineButton } from "../../../shared/ForwardOutlineButton";
import { ReactComponent as IconFreight } from "../../../assets/icons/icon_freight_white.svg";
import { ForwardInput } from "../../../shared/ForwardInput";
import { ReactComponent as IconX } from "../../../assets/icons/icon_x.svg";

const EntryHeadline = styled.span`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
  display: inline-block;
`;

const InvisibleButton = styled.button`
  border: none !important;
  outline: none !important;
  padding: 2px;
  background-color: transparent;
  cursor: pointer;
  color: #061a32;
  svg {
    width: 20px;
    height: 20px;
  }
`;

type Props = {
  load: Load;
  onUpdateLoad: (load: Load) => void;
  onAddClicked: () => void;
  onRemoveClicked: () => void;
  shouldShowRemoveButton: boolean;
  shouldShowAddButton: boolean;
  loadSuffix?: string;
};

export class LoadInput extends React.Component<Props> {
  render() {
    const {
      load,
      onUpdateLoad,
      onAddClicked,
      onRemoveClicked,
      loadSuffix,
      shouldShowRemoveButton,
      shouldShowAddButton
    } = this.props;
    const hasCustomLabel =
      load.label === "nicht palettiert, eigenes Maß" ||
      load.label === "palettiert, eigenes Maß";
    return (
      <Row type="flex" align="middle">
        <Col span={21} md={21} xs={18}>
          <EntryComponentContainer>
            <Row type="flex" justify="space-between" align="middle">
              <Col span="auto">
                <EntryHeadline>Fracht {loadSuffix}</EntryHeadline>
              </Col>
              {shouldShowRemoveButton && (
                <Col span="auto">
                  <InvisibleButton onClick={onRemoveClicked}>
                    <IconX />
                  </InvisibleButton>
                </Col>
              )}
            </Row>
            <Row type="flex">
              <Col span={23}>
                <Row
                  type="flex"
                  gutter={hasCustomLabel ? 24 : 44}
                  justify="space-between"
                >
                  <Col
                    span={hasCustomLabel ? 10 : 15}
                    md={hasCustomLabel ? 10 : 15}
                    xs={24}
                  >
                    <LoadSelect
                      value={load}
                      onSelect={value => onUpdateLoad(value)}
                    />
                  </Col>
                  {hasCustomLabel && (
                    <Col span={7} md={7} xs={24}>
                      <ForwardInput
                        label="Bezeichnung"
                        value={load.customLabel}
                        hasError={hasCustomLabel && !load.customLabel}
                        onChange={event =>
                          onUpdateLoad({
                            ...load,
                            customLabel: event.target.value
                          })
                        }
                      />
                    </Col>
                  )}
                  <Col
                    span={hasCustomLabel ? 7 : 9}
                    md={hasCustomLabel ? 7 : 9}
                    xs={24}
                  >
                    <QuantityInput
                      value={load.count}
                      onChange={value =>
                        onUpdateLoad({ ...load, count: value })
                      }
                    />
                  </Col>
                </Row>
                <Row type="flex" gutter={24}>
                  <Col span={6} md={6} xs={12}>
                    <ForwardNumberInput
                      label="* Länge"
                      placeholder="in cm"
                      min={0}
                      hasError={load.length === 0}
                      value={load.length === 0 ? undefined : load.length}
                      // disabled={load.type === LoadType.Europallet}
                      onChange={value =>
                        onUpdateLoad({ ...load, length: value || 0 })
                      }
                    />
                  </Col>
                  <Col span={6} md={6} xs={12}>
                    <ForwardNumberInput
                      label="* Breite"
                      placeholder="in cm"
                      min={0}
                      hasError={load.width === 0}
                      value={load.width === 0 ? undefined : load.width}
                      // disabled={load.type === LoadType.Europallet}
                      onChange={value =>
                        onUpdateLoad({ ...load, width: value || 0 })
                      }
                    />
                  </Col>
                  <Col span={6} md={6} xs={12}>
                    <ForwardNumberInput
                      label="* Höhe"
                      placeholder="in cm"
                      min={0}
                      hasError={load.height === 0}
                      value={load.height === 0 ? undefined : load.height}
                      onChange={value =>
                        onUpdateLoad({ ...load, height: value || 0 })
                      }
                    />
                  </Col>
                  <Col span={6} md={6} xs={12}>
                    <ForwardNumberInput
                      label="* Gesamtgewicht"
                      placeholder="in kg"
                      min={0}
                      hasError={load.totalWeight === 0}
                      value={
                        load.totalWeight === 0 ? undefined : load.totalWeight
                      }
                      onChange={value =>
                        onUpdateLoad({ ...load, totalWeight: value || 0 })
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </EntryComponentContainer>
        </Col>
        {shouldShowAddButton && (
          <Col span={3} md={3} xs={6} style={{ marginLeft: "-20px" }}>
            <Row type="flex" align="middle">
              <Col span={12}>
                <ForwardOutlineButton
                  isDisabled={false}
                  icon={IconFreight}
                  onClick={onAddClicked}
                />
              </Col>
              <Col span={12}>
                <Label>Fracht hinzufügen</Label>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    );
  }
}
